import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import * as Types from './types';

export const createMeeting = () =>
    RESTClient.postAuthenticatedObservable('v2/famly-live/meetings').map<any, {famlyMeeting: Types.FamlyMeeting}>(
        response => ({
            famlyMeeting: Types.famlyMeetingFromAPI(response),
        }),
    );

export const getMeeting = (famlyLiveMeetingId: string, refreshToken: string) => {
    if (refreshToken) {
        return RESTClient.getObservable(`v2/famly-live/meetings/${famlyLiveMeetingId}`, {refreshToken}).map<
            any,
            {famlyMeeting: Types.FamlyMeeting}
        >(response => ({famlyMeeting: Types.famlyMeetingFromAPI(response)}));
    } else {
        return RESTClient.getAuthenticatedObservable(`v2/famly-live/meetings/${famlyLiveMeetingId}`).map<
            any,
            {famlyMeeting: Types.FamlyMeeting}
        >(response => ({famlyMeeting: Types.famlyMeetingFromAPI(response)}));
    }
};

export const getJoinToken = (famlyLiveMeetingId: string) =>
    RESTClient.getAuthenticatedObservable(
        `v2/famly-live/meetings/${famlyLiveMeetingId}?generateExternalJoinUrl=1`,
        {},
        {suppressErrors: true},
    ).map<any, {externalJoinUrl: string}>(response => ({externalJoinUrl: response.externalJoinUrl}));
